import Axios from "axios";
import { URLS } from "./urls";
import { createCancelableRequest } from "../_helpers/createCancelableRequest";


export const getProjectsInfoForOverview = (data) => Axios.post(URLS.GET_PROJECTS_INFO_FOR_OVERVIEW, data);
export const getQuotations = data => createCancelableRequest(
    Axios.post,
    URLS.GET_QUOTATIONS,
    data
  );
  export const getQuotationDetails= (quotationId) => Axios.get(URLS.GET_QUOTATIONS_DETAILS + quotationId);
  export const getDefaultValuesForIndividualOptions= (projectId) => Axios.get(URLS.GET_DEFAULT_VALUES_FOR_INDIVIDUAL_OPTIONS + projectId);
  export const getQuotationsDefaults= (buildingId) => Axios.get(URLS.GET_QUOTATIONS_DEFAULTS + buildingId);
  export const getHeaderList= (projectId) => Axios.get(URLS.GET_HEADER_LIST + projectId);
  export const getCategoryList= (projectId) => Axios.get(URLS.GET_CATEGORY_LIST + projectId);
  export const getUnitsList= () => Axios.get(URLS.GET_UNITS_LIST);
  export const getTextPriceList= () => Axios.get(URLS.GET_TEXT_PRICE_LIST);
  export const getLimitedGuaranteeTextList= () => Axios.get(URLS.GET_LIMITED_GUARANTEE_TEXT_LIST);
  export const getBuyerInfo = (buildingId, app) =>Axios.get(`${URLS.GET_BUYER_INFO}${buildingId}?app=${app}`);
  export const updateBuyerInfo= (data) => Axios.post(URLS.UPDATE_BUYER_INFO,data );
  export const createAndSendQuotationForDigitalSigning= (data) => Axios.post(URLS.CREATE_AND_SEND_QUOTATION_FOR_DIGITAL_SIGNING,data );
  export const getWithdrawQuotation = (quoteId) => Axios.get(URLS.WITHDRAW_QUOTATION + quoteId);
  export const setProlongQuotation = (quoteId, days) => Axios.get(URLS.SET_PROLONG_QUOTATION + quoteId + "?days="+ days);
  export const addOrUpdateIndividualOption = (data) => Axios.post(URLS.ADD_OR_UPDATE_INDIVIDUAL_OPTION , data);
  export const getIndividualOption = (id) => Axios.get(URLS.GET_INDIVIDUAL_OPTION + id);
  export const quotationSendEmail = (quoteId, data) =>  Axios.post(`${URLS.SEND_EMAIL}${quoteId}`, data);




